import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

const mediaUrl = `https://s3-eu-central-1.amazonaws.com/websites-production/unicaf/wp-content/uploads/2015/01/usw-treforest.jpg`;

const Welcome = () => (
    
    <Card>    
        <CardMedia image={mediaUrl} style={{height: '20em', marginBottom: '.5em'}} alt="USW Campus"/>
        <CardContent>
            <Typography variant="h4" component="h2">
                Hello {localStorage.getItem('name')}
                <br/>
            </Typography>
            <Typography component="p" >
                Welcome to Vero, your access level is <b>{localStorage.getItem('role')}</b>{descriptoinString(localStorage.getItem('role'))}  
            </Typography>
        </CardContent>
    </Card>
);

const descriptoinString = (role) =>{
    switch (role) {
        case "Read Only":
          return ", you can only view content in Vero; no changes to content will be allowed.";
          break;
        case "Head of Subject":
          return ", you can view content in Vero, but only make changes to course and module team and leader information.";
          break;
        case "Course and Module Admin":
          return ", you can edit any content in Vero relating to courses or modules.";
          break;           
        case "Static Data Admin":
          return ", you can edit any content in Vero relating to courses, modules and static data.";
          break;      
        case "Super Admin":
          return ", you can edit any content in Vero, including historic versions of courses and modules.";
          break;  
        default:
            return "";
        }
} 
export default Welcome;